import React from "react";
import { withStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import { Paper, Grid } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Switch from '@material-ui/core/Switch';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    button: {
        margin: theme.spacing.unit / 2,
        marginTop: 0,
        marginBottom: 0,
    },
    paper: {
        padding: theme.spacing.unit,
        color: theme.palette.text.secondary,
        boxShadow: 'none',
    },
    tabBar: {
        boxShadow: 'none',
        paddingTop: 8,
    },
    icon: {
        margin: theme.spacing.unit,
        fontSize: 48,
    },
    avatar: {
        backgroundColor: red[500],
    },
    newAvatar: {
        backgroundColor: green[500],
    },
    bigAvatar: {
        width: 100,
        height: 100,
    },
});

class nhsSettings extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
        this.setState({ staffdata: this.props.staffdata });

        //console.log(this.props.staffdata);
    }

    state = {
        staffdata: this.props.staffdata,
    };

    componentDidMount() {
        this._isMounted = true;
    };

    componentDidUpdate(prevProps) {
        if (this.props.staffdata.staff_id !== prevProps.staffdata.staff_id) {
            this.setState({ staffdata: this.props.staffdata });
            //console.log(this.state);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleTextChange = name => event => {
        let sdatatmp = this.state.staffdata;

        sdatatmp[name] = event.target.value;

        this.setState({ staffdata: sdatatmp });

        //console.log({change: name+':'+event.target.value});
    };

    handleSwitchChange = name => event => {
        let sdatatmp = this.state.staffdata;

        sdatatmp[name] = event.target.checked;

        this.setState({ staffdata: sdatatmp });

        //console.log({change: name+':'+event.target.checked});
    };

    handleClickShowPin = () => {
        this.setState(state => ({ showPin: !state.showPin }));
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Paper className={classes.paper}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <InputLabel htmlFor="staff-gdcno">GDC Number</InputLabel>
                                <Input id="staff-gdcno" placeholder="" value={this.state.staffdata.nhsedi_gdcno}
                                    onChange={this.handleTextChange('nhsedi_gdcno')} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <InputLabel htmlFor="staff-udaalloc">UDA Allocation</InputLabel>
                                <Input id="staff-udaalloc" placeholder="" value={this.state.staffdata.nhsedi_alloc}
                                    onChange={this.handleTextChange('nhsedi_alloc')} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <InputLabel htmlFor="staff-pin">PIN Number</InputLabel>
                                <Input
                                    id="staff-pin"
                                    type={this.state.showPin ? 'text' : 'password'}
                                    value={this.state.staffdata.nhsedi_pin}
                                    name="staffpin"
                                    onChange={this.handleTextChange('nhsedi_pin')}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Toggle pin visibility"
                                                onClick={this.handleClickShowPin}
                                            >
                                                {this.state.showPin ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch color="primary"
                                    id="staff-autopin" checked={this.state.staffdata.nhsedi_autopin}
                                    value="y"
                                    onChange={this.handleSwitchChange('nhsedi_autopin')} />}
                                label="Auto PIN"
                                labelPlacement="start"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <InputLabel htmlFor="staff-pernum">Performer Number</InputLabel>
                                <Input id="staff-pernum" placeholder="" value={this.state.staffdata.nhsedi_perf}
                                    onChange={this.handleTextChange('nhsedi_perf')} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <InputLabel htmlFor="staff-cno">Contract Numbers</InputLabel>
                                <Input id="staff-cno" placeholder="" value={this.state.staffdata.nhsedi_cno}
                                    multiline={true} rows="3"
                                    onChange={this.handleTextChange('nhsedi_cno')} />
                                <FormHelperText>Enter each contract number on a separate line</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    }
}

export default withStyles(styles)(nhsSettings);